var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{staticClass:"card-title card-heading py-1 draggable"},[_vm._v(" Drag Me ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }